import React from 'react'
import { Container, Card } from 'react-bootstrap'
import { CardRowItem } from '../../cardRowItem'
import CardEntry from './cardEntry'
import * as S from './proposalElements'
import * as P from './../pdf/pdfElements'
import { IProposalTakeHomeSectionProps } from './proposalInterfaces/takeHomeSectionProps'
import {
  formatCurrency,
  IsSpecialEmployer,
  useWindowSize,
} from 'application/helpers'
import globals from 'application/constants/globals'
import { getCurrentResolutionBreakPoint } from 'application/utils/utilityFunctions'
import { useSelector } from 'react-redux'

const TakeHomeSection = (props: IProposalTakeHomeSectionProps) => {
  const isDownloadingPdf = useSelector(
    (state: any) => state.downloadPdf.isDownloading
  )

  const resolutionBreakpoint = {
    nonDesktop: getCurrentResolutionBreakPoint(isDownloadingPdf),
  }

  const [width] = useWindowSize()
  let isDesktop = width >= resolutionBreakpoint.nonDesktop

  let isNSWHN = IsSpecialEmployer('NSWHN')

  let fbtMethod = props.data.fbtMethod
  let overTheCapMethod = props.data.overTheCapMethod
  let postTax = props.data.postTaxPerPay

  let GetFBTValuationText = () => {
    if (
      (props.data.fbtMethod && props.data.fbtMethod.toLowerCase() === 'ecm') ||
      (props.data.fbtMethod &&
        props.data.fbtMethod.toLowerCase().includes('cap') &&
        postTax &&
        postTax > 0)
    ) {
      return (
        ' Post-tax novated lease deduction (ECM) is calculated using an FBT Base value of ' +
        formatCurrency(props.data.vehicleFBTValue) +
        '.'
      )
    } else if (
      props.data.fbtMethod &&
      props.data.fbtMethod.toLowerCase() === 'fbt'
    ) {
      return (
        ' FBT is calculated using an FBT Base value of ' +
        formatCurrency(props.data.vehicleFBTValue) +
        '.'
      )
    } else {
      return ''
    }
  }

  let fbtValuationText = GetFBTValuationText()

  let GetFBTMethodText = () => {
    if (
      fbtMethod &&
      overTheCapMethod &&
      postTax &&
      fbtMethod.toLowerCase() === 'ecm' &&
      overTheCapMethod.toLowerCase().includes('cap') &&
      postTax == 0
    ) {
      return 'Using your CAP'
    } else if (
      fbtMethod &&
      overTheCapMethod &&
      postTax &&
      fbtMethod.toLowerCase() === 'ecm' &&
      overTheCapMethod.toLowerCase().includes('cap') &&
      postTax > 0
    ) {
      return 'Using your CAP and ECM'
    } else if (fbtMethod && fbtMethod.toLowerCase().includes('cap')) {
      return postTax > 0 ? 'Using your CAP and ECM' : 'Using your CAP'
    } else {
      return fbtMethod
    }
  }

  let fbtText = GetFBTMethodText()

  let isTaxShare = props.data.taxShare.toLowerCase() === 'yes'

  const CardBody = () => {
    return (
      <Card.Body>
        {isNSWHN && (
          <div className="font-weight-bold">
            <CardRowItem
              title="FBT Method"
              value={fbtText}
              id="takehomesection.fbtMethod"
            />
          </div>
        )}
        <S.BrandDefaultText
          className={
            globals.isBrandRS ? 'mb-3 font-weight-bold' : 'font-weight-bold'
          }
        >
          PRE-TAX
        </S.BrandDefaultText>
        <CardEntry
          title="Gross Income"
          value={formatCurrency(props.data.grossSalaryPerPay)}
          id="takehomesection.grosssalary"
          boldText={globals.isBrandRS}
          boldValue={globals.isBrandRS}
        />
        <CardEntry
          title="Pre-tax novated lease deduction"
          value={formatCurrency(props.data.preTaxPerPay)}
          id="takehomesection.pretaxdeduction"
        />
        {isTaxShare && (
          <CardEntry
            title="Tax Share Deduction"
            value={formatCurrency(props.data.taxSharePerPay)}
            id="takehomesection.pretaxdeduction"
          />
        )}
        <CardEntry
          title="Other salary packaging (Pre-tax)"
          value={formatCurrency(props.data.otherPreTaxPerPay)}
          id="takehomesection.otherpretax"
        />
        <hr></hr>
        <div>
          <CardEntry
            title="Resulting taxable income"
            value={formatCurrency(props.data.netSalaryPerPay)}
            boldText
            boldValue
            id="takehomesection.netsalary"
          />
        </div>
        <br />
        <CardEntry
          title="FBT"
          value={formatCurrency(props.data.fbtPerPay)}
          id="takehomesection.fbt"
        />
        <CardEntry
          title="Tax and medicare deduction"
          value={formatCurrency(props.data.taxMedicarePerPay)}
          id="takehomesection.medicare"
        />
        <hr></hr>
        <div>
          <CardEntry
            title="Resulting net income"
            value={formatCurrency(props.data.netIncomePerPay)}
            boldText
            boldValue
            id="takehomesection.netincome"
          />
        </div>
        <br />
        <S.BrandDefaultText
          className={
            globals.isBrandRS ? 'font-weight-bold mb-3' : 'font-weight-bold'
          }
        >
          POST-TAX
        </S.BrandDefaultText>
        <CardEntry
          title="Post-tax novated lease deduction (ECM)"
          value={formatCurrency(props.data.postTaxPerPay)}
          id="takehomesection.posttax"
        />
        <CardEntry
          title="Other salary packaging items"
          value={formatCurrency(props.data.otherPostTaxPerPay)}
          id="takehomesection.otherposttax"
        />
        <hr></hr>
        <div>
          <CardEntry
            title="Resulting take home pay"
            value={formatCurrency(props.data.takeHomePerPay)}
            boldText
            boldValue
            id="takehomesection.takehomeperpay"
          />
        </div>
        <br />
        <S.BrandDefaultText>
          Disclaimer: The pre-tax salary in the calculations is net of your
          employer's compulsory superannuation guarantee contribution. The Tax
          and Medicare calculations do not take into account any HECS/HELP
          repayments that may apply to your personal financial circumstances.
          {fbtValuationText && (
            <span
              className="font-weight-bold"
              id="takehomesection.fbtvaluation"
            >
              {fbtValuationText}
            </span>
          )}
        </S.BrandDefaultText>
      </Card.Body>
    )
  }
  return (
    <div className="card-section print-page-break-before" id="takehomesection">
      <Container className="section mt-4">
        {!props.pdf && (
          <Card className="mb-13rem card-shadow">
            <Card.Header className="border-bottom-0">
              <S.CardHeader id="takehomesection.title">
                {props.title}
              </S.CardHeader>
            </Card.Header>
            <CardBody />
          </Card>
        )}

        {props.pdf && (
          <P.StyledCard className="mb-13rem">
            <P.StyledCardHeader>
              <P.StyledCardHeaderText id="takehomesection.title">
                {props.title}
              </P.StyledCardHeaderText>
            </P.StyledCardHeader>
            <CardBody />
          </P.StyledCard>
        )}
      </Container>
    </div>
  )
}

export default TakeHomeSection
